import React from 'react';
import { useAppStore } from '../../../GlobalStore/GlobalStore';
import { requestProjectFiles } from '../../../Utils/jsBridge/sender/ide/requestProjectFiles';

interface NoEmbeddingsPromptProps {}

const NoEmbeddingsPrompt: React.FC<NoEmbeddingsPromptProps> = () => {
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment, vscode } = environmentObj;

    const handleYes = () => {
        // Close the popup and trigger embeddings creation
        setDynamicStateObj({ visiblePopup: null });
        requestProjectFiles(environment, vscode);
    };

    const handleNo = () => {
        // Show the second popup with instructions
        setDynamicStateObj({ visiblePopup: 'noEmbeddingsInstructions' });
    };

    return (
        <div className="fixed inset-0 bg-neutral-100/95 dark:bg-neutral-900/95 flex items-center justify-center p-4 z-50">
            <div className="bg-neutral-300 dark:bg-neutral-800/80 rounded-xl shadow-2xl w-[98%] sm:w-11/12 max-w-md overflow-hidden border border-neutral-700/50">
                <div className="p-6">
                    <h2 className="text-xl font-bold mb-4 dark:text-white text-center">
                        No embeddings found for project
                    </h2>
                    <p className="text-center mb-6 dark:text-neutral-200">
                        Would you like to set them up?
                    </p>
                    <p className="text-center mb-6 text-sm dark:text-neutral-400">
                        This is required to allow the AI to semantically search around your codebase.
                    </p>
                    <div className="flex justify-center space-x-4">
                        <button
                            onClick={handleYes}
                            className="bg-green-600 px-6 py-2 rounded-full hover:bg-green-700 transition-colors duration-200 text-white"
                        >
                            Yes
                        </button>
                        <button
                            onClick={handleNo}
                            className="bg-red-600 px-6 py-2 rounded-full hover:bg-red-700 transition-colors duration-200 text-white"
                        >
                            No
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default NoEmbeddingsPrompt;